$(document).ready(function () {
    initSelects();
    initCookieNotification();
    initMainMenu();
    toggleMainMenu();
    slickSlider();
    initSlickSliderReviews();
    processHeaderClass();
});

$('#back-to-top, #mobile-view-to-top').click(function (event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    },
        1000
    );
});


$(window).scroll(function () {
    processHeaderClass();
    var scroll = $(window).scrollTop();

    if (scroll == 0) {
        $("#back-to-top, #mobile-view-to-top").addClass("fade");
    } else {
        $("#back-to-top, #mobile-view-to-top").removeClass("fade");

    }
});

var overlay = $('#overlay');
overlay.click(function () {
    var target = $('#' + $(this).data('caller'));
    target.click();
});


function initSelects() {
    var selects = $('select.styled:not(.done)');
    styleSelects();

    $(document).on('click', 'select.styled', function () {
        $(this)
            .parent()
            .focus();
    });

    $(document).on('click', '.select-value', function () {
        $(this)
            .parent()
            .focus();
    });

    $(document).on('click', '.select-options .option', function (e) {
        var wrap = $(this).parents('.select-wrap');
        var selectValue = wrap.find('.select-value');
        wrap.removeClass('clicked');
        selectValue.html($(this).html());
        wrap.find('select')
            .val($(this).attr('data-value'))
            .change();
        $('.option', wrap).removeClass('selected');
        $(this).addClass('selected');
        if ($(this).attr('data-default')) {
            selectValue.removeClass('selected');
        } else {
            selectValue.addClass('selected');
        }
        e.stopImmediatePropagation();
        e.stopPropagation();
    });

    $(document).on('keypress', '.select-options .option', function (e) {
        if (e.charCode == 13) {
            var wrap = $(this).parents('.select-wrap');
            var selectValue = wrap.find('.select-value');
            $('.option', wrap).removeClass('selected');
            $(this).addClass('selected');
            if ($(this).attr('data-default')) {
                selectValue.removeClass('selected');
            } else {
                selectValue.addClass('selected');
            }
            selectValue.html($(this).html());
            wrap.find('select')
                .val($(this).attr('data-value'))
                .change();
        }
    });

    $(document).on('focusin', '.select-wrap', function (e) {
        $(this).addClass('clicked');
        e.stopImmediatePropagation();
        e.stopPropagation();
    });

    $(document).on('focusout', '.select-wrap', function (e) {
        $(this).removeClass('clicked');
        e.stopImmediatePropagation();
        e.stopPropagation();
    });
    // find option by pressed keys
    var typingTimer;
    var doneTypingInterval = 700;
    var needle = '';

    $(document).on('keyup', '.select-wrap', function (e) {
        if (e.which == 27) {
            $(this).removeClass('clicked');
            return false;
        }

        needle += e.key;
        clearTimeout(typingTimer);
        selectWrap = $(this);

        typingTimer = setTimeout(function () {
            doneTyping(selectWrap);
        }, doneTypingInterval);
    });

    function doneTyping(selectWrap) {
        var opt = $('.option', selectWrap).filter(function () {
            var text = $(this)
                .text()
                .toLowerCase()
                .replace(/\s/g, '');
            needle = needle.replace(/\s/g, '');
            return text.indexOf(needle) === 0;
        });
        if (opt.length > 0) {
            selectWrap
                .find('select-options')
                .mCustomScrollbar('scrollTo', opt.eq(0).position().top);
            opt.eq(0).click();
        }
        needle = '';
    }
}

function styleSelects() {
    var selects = $('select.styled:not(.done)');

    selects.each(function () {
        $(this).wrap('<div class="select-wrap"></div>');
        var wrap = $(this).parent();
        var selected = $(this).find(':selected');
        var def = $(this).find('[data-default="true"]');
        var notdefault = '';
        selected.attr('selected', true);

        if (selected.val() != def.val()) {
            notdefault = true;
        }

        wrap.attr('tabindex', '0');
        wrap.append(
            '<div class="select-value ' +
            (notdefault ? 'selected' : '') +
            '">' +
            (typeof selected.data('background') == 'string' ?
                '<span class="img" style="background:' +
                selected.data('background') +
                '"></span>' :
                '') +
            selected.text() +
            '</div>'
        );
        var html = '<div class="select-options">';
        $(this)
            .find('option')
            .each(function () {
                html +=
                    '<div class="option ' +
                    ($(this).attr('selected') ? 'selected' : '') +
                    '" data-value="' +
                    $(this).val() +
                    '" ' +
                    ($(this).data('default') ? 'data-default="true"' : '') +
                    ' tabindex="0">' +
                    (typeof $(this).data('background') == 'string' ?
                        '<span class="img" style="background:' +
                        $(this).data('background') +
                        '"></span>' :
                        '') +
                    $(this).text() +
                    '</div>';
            });
        html += '</div>';

        wrap.append(html);
        wrap.addClass($(this).attr('class'));
        $(this).addClass('done');

        if (
            $('.select-options', wrap).outerHeight() >=
            parseInt($('.select-options', wrap).css('max-height'))
        ) {
            $('.select-options', wrap).mCustomScrollbar({
                scrollInertia: 150
            });
        }
    });
}

function setCookie(key, value, time) {
    var expires = new Date();

    if (!time) {
        var time = expires.setMonth(expires.getMonth() + 1);
    }

    expires.setTime(time);

    document.cookie =
        key +
        '=' +
        value +
        (expires ? ';expires=' + expires.toUTCString() : '');
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : false;
}


function initCookieNotification() {
    var agreed = getCookie('cookie-policy-agreed');
    var wrap = $('#cookie-notification');
    var agreeButton = $('.agree', wrap);

    if (!agreed) {
        $('#cookie-notification').addClass('show');
    }

    agreeButton.on('click', function () {
        wrap.removeClass('show');
        var date = new Date();
        date.setFullYear(date.getFullYear() + 1);

        console.log(date.getTime());

        setCookie('cookie-policy-agreed', true, date.getTime());
        return false;
    });
}

function initMainMenu() {
    var categoryMenu = $('#category-menu');
    var categoryToggler = $('#category-toggler');
    var subCats = $('.subcategory-wrap', categoryMenu);

    initCategoryMenu();

    function initCategoryMenu() {
        var activeSubcat,
            activeLink = null;

        $('.navbar-toggler').click(function () {
            $(this).toggleClass('active');
            overlay.data('caller', $(this).attr('id'));
            overlay.toggleClass('show', $(this).hasClass('active'));
        });

        categoryToggler.click(function (e) {
            e.preventDefault();
            categoryMenu.toggleClass('show');
            $(this).toggleClass('active', categoryMenu.hasClass('show'));
            overlay.data('caller', $(this).attr('id'));
            overlay.toggleClass(
                'show show-header',
                categoryMenu.hasClass('show')
            );
            return false;
        });

        $(document).on('click', function (e) {
            var target = e.relatedTarget ? $(e.relatedTarget) : $(e.target);
            if (typeof target != 'undefined' && target != 'null') {
                if (
                    target.parents('#category-menu-wrap').length > 0 ||
                    target.is('#category-menu-wrap') ||
                    target.parents('.bottom').length > 0 ||
                    target.is('.bottom')
                ) { } else {
                    $('#category-menu').removeClass('show');
                    $('#category-toggler').removeClass('active');
                    overlay.removeClass('show');
                }
            } else {
                $('#category-menu').removeClass('show');
                $('#category-toggler').removeClass('active');
                overlay.removeClass('show');
            }
        });

        $(document).on('keyup', function (e) {
            if (e.keyCode === 27) {
                $('#category-menu').removeClass('show');
                $('#category-toggler').removeClass('active');
                overlay.removeClass('show');
            }
        });

        $(categoryMenu).on('keyup', function (e) {
            if (e.keyCode === 39) {
                activeSubcat.focus();
            }

            if (e.keyCode === 37) {
                activeLink.focus();
            }
        });

        $('.left .nav-link').on(
            'mouseenter mouseleave focusin focusout',
            function (e) {
                activeLink = $(this);
                switchActiveSubMenu();
                e.stopPropagation();
            }
        );

        subCats.on('focus', function (e) {
            e.stopImmediatePropagation();
            $('a', $(this))
                .eq(0)
                .focus();
            return false;
        });

    }
}

function initMap(params) {
    if (typeof google == 'undefined') {
        return;
    }
    var gm = google.maps;

    if ($(params.map).length < 1) {
        return;
    }

    map = new google.maps.Map(params.map, {
        zoom: params.zoom,
        center: new gm.LatLng(params.center.lat, params.center.lng),
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: [{
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [{
                "saturation": 36
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 40
            }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "visibility": "on"
            },
            {
                "color": "#000000"
            },
            {
                "lightness": 16
            }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 20
            }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 17
            },
            {
                "weight": 1.2
            }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 20
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 21
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 17
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 29
            },
            {
                "weight": 0.2
            }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 18
            }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 16
            }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 19
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{
                "color": "#000000"
            },
            {
                "lightness": 17
            }
            ]
        }
        ]

    });

    map.scrollwheel = false;

    for (var i in params.markers) {
        if (params.markers.hasOwnProperty(i)) {
            var element = params.markers[i];

            var m = new MarkerWithLabel({
                position: new gm.LatLng(
                    element.position.lat,
                    element.position.lng
                ),
                icon: ' ',
                map: map,
                labelContent: element.labelContent,
                labelAnchor: new google.maps.Point(15, 40)
            });
        }
    }
}

function slickSlider() {
    $('.slick-slider-wrap').slick({
        prevArrow: $('.prev-white-btn'),
        nextArrow: $('.next-grey-btn'),
        slidesToShow: 2,
    });

    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav',
        fade: true,
        speed: 500,
        adaptiveHeight: true,

    });
    $('.slider-nav').slick({
        slidesToShow: 9,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        prevArrow: $('.prev-white-btn'),
        nextArrow: $('.next-grey-btn'),
        responsive: [{
            breakpoint: 991,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }
        ]

    });

}




$('.work-col-wrap').hover(
    function () {
        $(this).children('.hover-section').addClass('hovered')
    },
    function () {
        $(this).children('.hover-section').removeClass('hovered')
    }
)

function toggleMainMenu() {
    $('.btn-mobile-toggle').click(
        function () {
            $(this).closest('.top').siblings('.main-navigation-mobile').fadeIn(200);
            $('#overlay, #menu-overlay').fadeIn(200);
        }
    );
    $('.close-btn').click(
        function () {
            $(this).closest('.main-navigation-mobile').fadeOut(200);
            $('#overlay, #menu-overlay').fadeOut(200);
        }
    );
    $('#service-next').click(
        function () {
            $(this).closest('.mobile-menu-wrap').hide();
            $(this).closest('.mobile-menu-wrap').siblings('.mobile-menu-subwrap').fadeIn(200);
        }
    );
    $('#go-back').click(
        function () {
            $(this).closest('.mobile-menu-subwrap').hide();
            $(this).closest('.mobile-menu-subwrap').siblings('.mobile-menu-wrap').fadeIn(200);
        }
    );
    $('#service-next-lang').click(
        function () {
            $(this).closest('.mobile-menu-wrap').hide();
            $(this).closest('.mobile-menu-wrap').siblings('.mobile-menu-subwrap-lang').fadeIn(200);
        }
    );
    $('#go-back-lang').click(
        function () {
            $(this).closest('.mobile-menu-subwrap-lang').hide();
            $(this).closest('.mobile-menu-subwrap-lang').siblings('.mobile-menu-wrap').fadeIn(200);
        }
    );
}

function initSlickSliderReviews() {

    var slickElement = $('.review-col');
    var time = 2;
    var $bar,
        tick,
        percentTime;

    slickElement.slick({
        prevArrow: $('.prev-arrow'),
        nextArrow: $('.next-arrow'),
        vertical: true,
    });

    $bar = $('.slider-progress .progress-circle');
    $barRound = $('.progress-circle');

    function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 20);
    }
    var $rbar = $('.progress-circle circle');
    var rlen = 2 * Math.PI * $rbar.attr('r');

    var slideshow_speed = 100;
    if (typeof SLIDESHOW_SPEED != 'undefined') {
        slideshow_speed = SLIDESHOW_SPEED;
    }

    function interval() {

        percentTime += 1 / (time + 0.1);
        $bar.css({
            width: percentTime + '%'
        });
        $rbar.css({
            'stroke-dasharray': rlen,
            'stroke-dashoffset': rlen * (1 - percentTime / slideshow_speed)
        });

        if (percentTime >= slideshow_speed) {
            slickElement.slick('slickNext');
            startProgressbar();
        }
    }

    function resetProgressbar() {
        $bar.css({
            width: 0 + '%'
        });
        clearTimeout(tick);
    }

    $('.review-col').hover(function(ev){
        clearInterval(tick);
    }, function(ev){
        tick = setInterval( interval, 20);
    });

    startProgressbar();

    var reviewText = $('.review-text');
    var circleWrap = $('.progress-circle-wrap');
    // On before slide change
    slickElement.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        circleWrap.removeClass('show');
        circleWrap.eq(nextSlide).addClass('show');
        reviewText.removeClass('active');
        reviewText.eq(nextSlide).addClass('active');
        $('.slider-wrap').children('.reflection-before-slide').removeClass("fade");
    });

    slickElement.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $('.slider-wrap.slick-current').children('.reflection-before-slide').addClass("fade");
    });

    reviewText.click(function () {
        var index = reviewText.index($(this));
        slickElement.slick('slickGoTo', index);
        return false;
    })
}


var headerElem = document.getElementById('header');
if (headerElem) {
    var headerStartHeight = headerElem.clientHeight;
}

var prevScrollTop = 0;

function processHeaderClass() {
    if (!headerElem) {
        return false;
    }

    if (Math.abs(prevScrollTop - window.scrollY) > 10) {

        $(headerElem).toggleClass(
            'scroll-down',
            prevScrollTop < window.scrollY
        );
        $(headerElem).toggleClass('scroll-up', prevScrollTop > window.scrollY);
    }

    if (window.scrollY >= headerStartHeight) {
        headerElem.classList.add('scrolled');

    } else {
        headerElem.classList.remove('scrolled');

    }
    prevScrollTop = window.scrollY;
}


$(".toggle-properties").click(function (e) {
    e.preventDefault();
    $(this).siblings(".properties-wrapper").toggle();
});

$(".read-more").click(function (e) {
    e.preventDefault();
    $(this).hide();
    $(this).closest(".text-wrapper").find(".base-text").css("margin-bottom", "10px");
    $(this).closest(".text-wrapper").find(".toggle-text").show();
});

$("#pills-tab").on("shown.bs.tab", function (e) {
    e.preventDefault();
    if ($("#pills-home-tab").hasClass("active")) {
        $(this).closest(".contact-form-wrap").children(".project-title, .consult-title").hide();
        $(this).closest(".contact-form-wrap").children(".contact-title").show();

    } else if ($("#pills-profile-tab").hasClass("active")) {
        $(this).closest(".contact-form-wrap").children(".contact-title, .consult-title").hide();
        $(this).closest(".contact-form-wrap").children(".project-title").show();

    } else if ($("#pills-contact-tab").hasClass("active")) {
        $(this).closest(".contact-form-wrap").children(".contact-title, .project-title").hide();
        $(this).closest(".contact-form-wrap").children(".consult-title").show();
    }
});

$(".popup-e-shop").click(function (e) {
    e.preventDefault();
    $(".e-shop-popup").show();
    $("body").css("overflow-y", "hidden");
});

$(".close-btn-popup").click(function (e) {
    e.preventDefault();
    $(this).closest(".e-shop-popup").hide();
    $("body").css("overflow-y", "unset");
});

$(".popup-e-shop-second").click(function (e) {
    e.preventDefault();
    $(".e-shop-popup-second").show();
    $("body").css("overflow-y", "hidden");
});

$(".close-btn-popup-lower-second").click(function (e) {
    e.preventDefault();
    $(this).closest(".e-shop-popup-second").hide();
    $("body").css("overflow-y", "unset");
});
$(".popup-e-shop-third").click(function (e) {
    e.preventDefault();
    $(".e-shop-popup-third").show();
    $("body").css("overflow-y", "hidden");
});

$(".close-btn-popup-lower-third").click(function (e) {
    e.preventDefault();
    $(this).closest(".e-shop-popup-third").hide();
    $("body").css("overflow-y", "unset");
});
$(".popup-e-shop-fourth").click(function (e) {
    e.preventDefault();
    $(".e-shop-popup-fourth").show();
    $("body").css("overflow-y", "hidden");
});

$(".close-btn-popup-lower-fourth").click(function (e) {
    e.preventDefault();
    $(this).closest(".e-shop-popup-fourth").hide();
    $("body").css("overflow-y", "unset");
});

function addBottomBorderEshopDevelopment() {
    $(document).scroll(function () {
        if ($(this).scrollTop() >= $('#types').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".types.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#process').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".process.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#functionality').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".functionality.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#integration').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".integration.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#advantages').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".advantages.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#cms').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".cms.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#maintenance').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".maintenance.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#hosting').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".hosting.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#marketing').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".marketing.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#projects').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".projects.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#reviews').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".reviews.nav-link").addClass("active");
        }
    });
};
function addBottomBorderHomepageDevelopment() {
    $(document).scroll(function () {
        if ($(this).scrollTop() >= $('#types').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".types.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#process').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".process.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#cms').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".cms.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#maintenance').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".maintenance.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#hosting').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".hosting.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#marketing').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".marketing.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#projects').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".projects.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#reviews').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".reviews.nav-link").addClass("active");
        }
    });
};

function addBottomBorderDesignDevelopment() {
    $(document).scroll(function () {
        if ($(this).scrollTop() >= $('#design-section').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".design-section.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#process').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".process.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#functionality').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".functionality.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#designer-tools').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".designer-tools.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#projects').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".projects.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#reviews').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".reviews.nav-link").addClass("active");
        }
    });
};
function addBottomBorderUxDevelopment() {
    $(document).scroll(function () {
        if ($(this).scrollTop() >= $('#what-is-ux').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".what-is-ux.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#execution-scenarious').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".execution-scenarious.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#advantages').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".advantages.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#service-breakdown').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".service-breakdown.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#projects').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".projects.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#reviews').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".reviews.nav-link").addClass("active");
        }
    });
};
function addBottomBorderSystemDevelopment() {
    $(document).scroll(function () {
        if ($(this).scrollTop() >= $('#system-types').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".system-types.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#process').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".process.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#advantages').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".advantages.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#technology').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".technology.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#maintenance').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".maintenance.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#projects').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".projects.nav-link").addClass("active");
        }
        if ($(this).scrollTop() >= $('#reviews').offset().top - 50) {
            $(".nav-link").removeClass("active");
            $(".reviews.nav-link").addClass("active");
        }
    });
};


if ($(".e-shop-development-body").length > 0) {
    $(document).ready(function () {
        addBottomBorderEshopDevelopment();
    });
}

if ($(".design-development-body").length > 0) {
    $(document).ready(function () {
        addBottomBorderDesignDevelopment();
    });
}
if ($(".ux-development-body").length > 0) {
    $(document).ready(function () {
        addBottomBorderUxDevelopment();
    });
}
if ($(".system-development-body").length > 0) {
    $(document).ready(function () {
        addBottomBorderSystemDevelopment();
    });
}
if ($(".homepage-development-body").length > 0) {
    $(document).ready(function () {
        addBottomBorderHomepageDevelopment();
    });
}


$(".our-works-gallery-menu").find(".nav-link").click(function (e) {
    e.preventDefault();
    $(".our-works-gallery-menu").find(".nav-link").removeClass("active");
    $(this).addClass("active");
});